<script lang="ts" setup>
	const props = defineProps<{
		timeStamp: string | null
		stop?: boolean
	}>()

	const countdowns = useCountdown(String(props.timeStamp ?? ''))

	const countdown = reactive({
		day: {
			value: 0 as number | string,
			label: 'D'
		},
		hour: {
			value: 0,
			label: 'H'
		},
		min: {
			value: 0,
			label: 'M'
		},
		sec: {
			value: 0,
			label: 'S'
		}
	})

	const updateTimer = () => {
		const seconds = countdowns.seconds
		const minutes = countdowns.minutes
		const hours = countdowns.hours
		const days = countdowns.days
		countdown.day.value = days > 0 ? days + 'D' : 0
		countdown.hour.value = hours > 0 ? hours : 0
		countdown.min.value = minutes > 0 ? minutes : 0
		countdown.sec.value = seconds > 0 ? seconds : 0
	}

	onMounted(() => {
		updateTimer()
	})
</script>

<template>
	<div class="flex justify-center">
		<div
			class="mx-auto inline-flex min-h-[64px] w-full max-w-[362px] items-center justify-center gap-x-2 rounded-lg bg-warning-500 p-4 text-white"
		>
			<div v-for="(item, key, i) in countdowns" :key="key">
				<span class="text-center text-base font-semibold text-white sm:text-2xl">
					<span v-if="key === 'days'"> {{ item }}D </span>
					<span v-else> {{ item }} </span>
					<span v-if="i + 1 !== Object.keys(countdown).length">:</span>
				</span>
			</div>
		</div>
	</div>
</template>
